import { defineMessages, FormattedMessage, injectIntl, intlShape } from "react-intl";
import PropTypes from "prop-types";
import { ErrorPropTypeShape } from "../../errors/ErrorDisplay";
import { Button, Link, Modal } from "@yoast/ui-library";
import React from "react";
import BrandInsightsIcon from "../../../src/icons/Yoast/Brand_Insights_Icon.svg";
import LockOpenIcon from "../../../src/icons/lock-open.svg";
import aiBrandInsightsPreviewImage from "../../../public/ai-brand-insights-preview-image.png";
import { getShopUrl } from "shared-frontend/functions/products";

import * as styles from "./styles.module.scss";

const messages = defineMessages( {
	ariaLabel: {
		id: "needBrandInsightsModal.ariaLabel",
		defaultMessage: "Need Brand Insights",
	},
	availableNow: {
		id: "needBrandInsightsModal.availableNow",
		defaultMessage: "AVAILABLE NOW - YOAST AI BRAND INSIGHTS",
	},
	header: {
		id: "needBrandInsightsModal.header",
		defaultMessage: "How does your brand show up in AI responses?",
	},
	description: {
		id: "needBrandInsightsModal.description",
		defaultMessage: "Track visibility, control perception, and stay ahead - tools to manage your AI presence are now live!",
	},
	upsellButtonText: {
		id: "needBrandInsightsModal.upsellButtonText",
		defaultMessage: "Unlock Yoast AI Brand Insights",
	},
	closeButtonText: {
		id: "needBrandInsightsModal.closeButtonText",
		defaultMessage: "Close",
	},
} );

/**
 * The modal that shows when the user tries to access Brand Insights without a valid license.
 * @param {object} props The component props.
 * @returns {Element} The NeedBrandInsightsModal component.
 * @constructor
 */
function NeedBrandInsightsModal( props ) {
	const shopUrl = getShopUrl();

	return (
		<Modal
			isOpen={ props.isOpen }
			onClose={ props.onClose }
			aria-label={ messages.ariaLabel.defaultMessage }
		>
			<Modal.Panel
				hasCloseButton={ false }
				className={ styles.needsBrandInsightsModal }
			>
				<Modal.CloseButton className="yst-bg-transparent yst-text-gray-500 focus:yst-ring-offset-0" />
				<img src={ aiBrandInsightsPreviewImage } alt="AI Brand Insights Preview" className={ styles.previewImage } />
				<p className={ styles.nowAvailable }>
					<img src={ BrandInsightsIcon } alt="" />
					<FormattedMessage { ...messages.availableNow } />
				</p>
				<Modal.Title size={ "2" } className={ "yst-flex yst-justify-center" }>
					<FormattedMessage { ...messages.header } />
				</Modal.Title>
				<p className={ styles.description }>
					<FormattedMessage { ...messages.description } />
				</p>
				<Link
					href={ `${shopUrl}/product/yoast-seo-ai-plus/` }
					target="_blank"
					rel="noopener noreferrer"
					tabIndex={ -1 }
				>
					<Button variant={ "upsell" } className={ styles.upsellButton }>
						<img src={ LockOpenIcon } alt="" />
						<FormattedMessage { ...messages.upsellButtonText } />
					</Button>
				</Link>
				<Button variant={ "tertiary" } onClick={ props.onClose } className={ styles.closeButton }>
					<FormattedMessage { ...messages.closeButtonText } />
				</Button>
			</Modal.Panel>
		</Modal>
	);
}

NeedBrandInsightsModal.propTypes = {
	intl: intlShape.isRequired,
	isOpen: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
	error: ErrorPropTypeShape,
};

NeedBrandInsightsModal.defaultProps = {
	isOpen: false,
};

export default injectIntl( NeedBrandInsightsModal );
